import React, { useState } from "react";
import Button from "@mui/material/Button";
import { openPopup } from "../../stateManagement/actions/popupActions";
import { ConfirmationPopUp } from "../popup/confirmationPopUp";

type ResetButtonProps = {
  onReset: () => void;
  buttonLabel: string; // Optional label for the button
  variant?: "text" | "outlined" | "contained"; // Button variant
  customClasses?: string; // Custom styles for the button
  color?:
    | "inherit"
    | "primary"
    | "secondary"
    | "success"
    | "error"
    | "info"
    | "warning"; // Button color
};

const ResetButton: React.FC<ResetButtonProps> = ({
  onReset,
  buttonLabel,
  variant = "outlined",
  color = "primary",
  customClasses = "",
}) => {
  const [confirmationPopUp, setConfirmationPopUp] = useState(false);

  const handleReset = () => {
    try {
      onReset();
      openPopup("Success", "Reset Successfull", () => {});
    } catch (error) {
      openPopup("Error", "Error while resetting", () => {});
    }
  };

  return (
    <>
      <Button
        variant={variant}
        color={color}
        onClick={() => setConfirmationPopUp(true)}
        className={customClasses}
        sx={{
          fontWeight: "bold",
          height: "40px",
          width: "145px",
        }}
      >
        {buttonLabel}
      </Button>
      <ConfirmationPopUp
        openConfirmModal={confirmationPopUp}
        message={"Are you sure you want to reset?"}
        setOpenConfirmModal={() => {
          setConfirmationPopUp(false);
        }}
        successMethod={handleReset}
      />
    </>
  );
};

export default ResetButton;
